<ion-app>
   <ion-menu contentId="main-content" menuId="main-menu">
    <ion-header>
      <ion-toolbar>
        <ion-title> {{ 'menu' | translate }}</ion-title>
        <!-- Close Button -->
        <ion-buttons slot="end">
          <ion-button menuClose (click)="onClose()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

      <ion-content>
      @if (isLoggedIn) {
        <ion-list>
          <ion-item lines="none" class="ion-activatable ion-focusable" (click)="userSettings()" style="cursor: pointer;">{{'USER_SETTINGS' | translate }}</ion-item>
          <ion-item lines="none" class="ion-activatable ion-focusable" (click)="openHelpPage(); onClose()" style="cursor: pointer;">{{'help' | translate }}</ion-item>
          <ion-item lines="none" class="ion-activatable ion-focusable" (click)="openInfoPage(); onClose()" style="cursor: pointer;">{{'APP_INFO_TITLE' | translate }}</ion-item>
          <ion-item lines="none" class="ion-activatable ion-focusable" (click)="openCookieSettings()" style="cursor: pointer;">Cookie settings</ion-item>
          
          <ion-item class="ion-activatable ion-focusable" (click)="userAccount()" style="cursor: pointer;">{{'ACCOUNT' | translate }}</ion-item> <!-- Show only if user logged in -->
          <hr>
          <ion-item lines="none" class="ion-activatable ion-focusable" (click)="userLogout()" style="cursor: pointer;">{{'logout' | translate }}</ion-item> <!-- Show only if user logged in -->
        </ion-list>
      } 
      @if (!isLoggedIn) {
        <ion-list>
          <ion-item lines="none" class="ion-activatable ion-focusable" (click)="userSettings()" style="cursor: pointer;">{{'USER_SETTINGS' | translate }}</ion-item>
          <ion-item lines="none" class="ion-activatable ion-focusable" (click)="openHelpPage(); onClose()" style="cursor: pointer;">{{'help' | translate }}</ion-item>
          <ion-item lines="none" class="ion-activatable ion-focusable" (click)="openInfoPage(); onClose()" style="cursor: pointer;">{{'APP_INFO_TITLE' | translate }}</ion-item>
          <ion-item lines="none" class="ion-activatable ion-focusable" (click)="openCookieSettings()" style="cursor: pointer;">Cookie settings</ion-item>
        </ion-list>
      }
      </ion-content>
      <ion-footer>
        <ion-toolbar>
          @if (!isLoggedIn) {
            <ion-button expand="block" class="ion-margin center-btn not-uppercase" menuClose style="font-size: 14px;" (click)="openLogin()">
              <ion-icon src="assets/icons/user-login-logo.svg"></ion-icon> 
              {{ 'login_button' | translate}}
            </ion-button>

            <ion-button expand="block" fill="outline" class="ion-margin center-btn not-uppercase" menuClose style="font-size: 14px;" (click)="openConfigurationModal()">
              <ion-icon name="add-outline"></ion-icon>
              {{'start_new_configuration_button' | translate}}
            </ion-button>
          }
          @if (isLoggedIn) {
            <ion-button expand="block" class="ion-margin center-btn not-uppercase" menuClose style="font-size: 14px;" (click)="openConfigurationModal()">
              <ion-icon name="add-outline"></ion-icon>
              {{'start_new_configuration_button' | translate}}
            </ion-button>

            <ion-button expand="block" fill="outline" class="ion-margin center-btn not-uppercase" menuClose style="font-size: 14px;" (click)="openSavedConfigurationModal()">
              <ion-icon src="assets/icons/home-24.svg"></ion-icon>
              {{'show_saved_configuration_button' | translate}}
            </ion-button>
          }
        </ion-toolbar>
      </ion-footer>
  </ion-menu>
  <ion-router-outlet id="main-content"></ion-router-outlet>

  @if (showCookieConsentBanner) {
    <div class="cookie-consent-backdrop" role="dialog" aria-modal="true" aria-label="Cookie preferences">
      <section class="cookie-consent-card">
        <h2>Cookie preferences</h2>
        <p>
          We use strictly necessary cookies to secure the application and keep it available.
          You can accept only essential cookies or allow all cookies.
        </p>
        <div class="cookie-consent-actions">
          <ion-button fill="outline" size="small" (click)="acceptEssentialCookies()">Essential only</ion-button>
          <ion-button size="small" (click)="acceptAllCookies()">Accept all</ion-button>
        </div>
      </section>
    </div>
  }
</ion-app>
